import { Outlet } from 'react-router-dom';
import { LayoutProvider } from '@/contexts/LayoutProvider';
import { Footer } from './Footer';
import { InviteGuard } from './InviteGuard';

/**
 * Generic layout component that provides consistent structure for all pages
 * Automatically includes a footer that positions itself based on page layout
 */
export default function Layout() {
  return (
    <LayoutProvider>
      <div className="min-h-screen bg-background">
        {/* Opens the invitation approve modal when arriving from an invite link */}
        <InviteGuard />

        {/* Page content renders here via Outlet */}
        <Outlet />

        {/* Footer automatically positions itself based on sidebar presence */}
        <Footer />
      </div>
    </LayoutProvider>
  );
}
